module.exports = __webpack_public_path__ + "img/6dots.44514739.svg";